// Regras de assinatura digital do receituário compartilhadas entre a listagem web e a mobile.

export const hasControlledMedicines = (prescription) =>
  (prescription.medicamentos ?? []).some((medicine) => medicine.controlled);

export const CONTROLLED_SIGNATURE_UNAVAILABLE =
  'Receita com medicamento controlado: a assinatura digital depende da numeração do SNCR (Anvisa), ainda não integrada. Imprima esta receita.';

export const formatPrescriptionSummary = (prescription) =>
  prescription ? `Receituário de ${prescription.data} · ${prescription.nomeDoDentista}` : null;
